'use client';

import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { LINKS } from '@/constants';
import { useAtomValue } from 'jotai';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../ui/card';

export const HelioFrame = () => {
  const tokenInfo = useAtomValue(tokenInfoAtom);

  if (!tokenInfo?.ca) return null;

  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle>Wallet Network</CardTitle>
        <CardDescription className="text-white">
          Is the wallet network of this token legit? Check it here.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="w-full h-[600px] rounded-xl overflow-hidden">
          <iframe
            src={`${LINKS.helio}/${tokenInfo.ca}`}
            className="w-full h-full border-0"
            title="Helio Frame"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-between w-full">
        <p className="text-right text-muted-foreground text-sm ml-auto">
          powered by{' '}
          <a
            className="text-white hover:text-purple-400"
            href={LINKS.helio}
            target="_blank"
            rel="noopener noreferrer"
          >
            Helio
          </a>
        </p>
      </CardFooter>
    </Card>
  );
};
